import React from "react";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/mock";

const TestimonialsSection = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="py-24 lg:py-32 bg-brand-bg"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-8 mb-16 items-end">
          <div className="lg:col-span-7">
            <p className="text-xs font-bold uppercase tracking-[0.24em] text-brand-cta mb-4 flex items-center gap-3">
              <span className="block w-10 h-px bg-brand-cta" />
              From the homeowners
            </p>
            <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-brand-ink leading-[0.95]">
              They invited us in. <br />
              <span className="italic font-light">They asked us back.</span>
            </h2>
          </div>
        </div>

        {/* Offset masonry */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={t.name}
              data-testid={`testimonial-${i}`}
              className={`bg-brand-surface border border-brand-border p-8 lg:p-10 flex flex-col gap-6 ${
                i % 2 === 1 ? "md:translate-y-12" : ""
              }`}
            >
              <Quote
                className="w-8 h-8 text-brand-cta"
                strokeWidth={1.5}
              />
              <p className="font-heading text-xl lg:text-2xl font-medium tracking-tight text-brand-ink leading-snug">
                "{t.quote}"
              </p>
              <div className="mt-auto pt-6 border-t border-brand-border flex justify-between items-end">
                <div>
                  <p className="font-bold text-sm text-brand-ink">{t.name}</p>
                  <p className="text-xs text-brand-inkSoft mt-1">
                    {t.location}
                  </p>
                </div>
                <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-brand-cta">
                  {t.project}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
